var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3" },
    [
      _c("plain-text-control", {
        attrs: {
          title: "BudgetaryEstimate.Investment.SupportApartments.Summary.Title"
        }
      }),
      _vm._v(" "),
      _c(
        "table",
        {
          staticClass: "table tablerow",
          attrs: {
            "aria-label": _vm.$t(
              "BudgetaryEstimate.Investment.SupportApartments.Summary.Title"
            )
          }
        },
        [
          _c("thead", [
            _c("tr", [
              _c("th", { staticClass: "w-60" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BudgetaryEstimate.Investment.SupportApartments.Apartment.Municipality"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "w-20 right" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BudgetaryEstimate.Investment.SupportApartments.Apartment.Count"
                      )
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("th", { staticClass: "w-20 right" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "BudgetaryEstimate.Investment.SupportApartments.Summary.AvgPrice"
                      )
                    )
                  )
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.items, function(item, index) {
              return _c("tr", { key: index }, [
                _c("th", { staticClass: "w-60 row-heading" }, [
                  _c("span", [_vm._v(_vm._s(item.municipality.name))])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "w-20 disabled-background right" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("formatNumber")(item.count)))
                  ])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "w-20 disabled-background right" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm._f("formatNumber")(item.avgPrice)))
                  ])
                ])
              ])
            }),
            0
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }